// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__2EZvX","Div":"CustomFadeBox_Div__C_VJj","LargeDiv":"CustomFadeBox_LargeDiv__1KJm-"};